import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Mail, BookOpen, MessageSquare } from 'lucide-react';
import SEO from '@/components/seo/SEO';

const SupportPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#f8f5ef] font-sans">
      <SEO title="Support - LendLifted" description="Get help with LendLifted seller financing checkout." canonical="/support" />

      <div className="container px-6 py-24 text-center md:py-32">
        <h1 className="mb-6 text-5xl font-extrabold tracking-tight text-slate-950 md:text-6xl">How can we support you?</h1>
        <p className="mx-auto max-w-2xl text-xl leading-relaxed text-slate-600">
          Whether you are setting up financing for the first time or scaling your team, we are here to help.
        </p>
      </div>

      <div className="container px-6 pb-32">
        <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-3">
          <Card className="group h-full cursor-pointer overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg">
            <CardHeader className="p-8 pb-4">
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-900 transition-transform group-hover:scale-110">
                <BookOpen size={28} strokeWidth={1.5} />
              </div>
              <CardTitle className="text-2xl font-bold">Guide Book</CardTitle>
            </CardHeader>
            <CardContent className="p-8 pt-2">
              <p className="mb-6 leading-relaxed text-slate-600">
                Step-by-step docs for quoting, sharing checkout links, and improving close rate with better follow-up.
              </p>
              <span className="border-b border-slate-900 pb-0.5 font-medium text-slate-900">Read Documentation</span>
            </CardContent>
          </Card>

          <Card className="group h-full cursor-pointer overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg">
            <CardHeader className="p-8 pb-4">
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-900 transition-transform group-hover:scale-110">
                <MessageSquare size={28} strokeWidth={1.5} />
              </div>
              <CardTitle className="text-2xl font-bold">FAQ</CardTitle>
            </CardHeader>
            <CardContent className="p-8 pt-2">
              <p className="mb-6 leading-relaxed text-slate-600">
                Quick answers to common questions about subscriptions, accounts, and technical setup.
              </p>
              <Link to="/faq" className="border-b border-slate-900 pb-0.5 font-medium text-slate-900">
                View FAQs
              </Link>
            </CardContent>
          </Card>

          <Card className="group h-full cursor-pointer overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg">
            <CardHeader className="p-8 pb-4">
              <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-900 transition-transform group-hover:scale-110">
                <Mail size={28} strokeWidth={1.5} />
              </div>
              <CardTitle className="text-2xl font-bold">Email Support</CardTitle>
            </CardHeader>
            <CardContent className="p-8 pt-2">
              <p className="mb-6 leading-relaxed text-slate-600">Need personalized help? Our team is ready to assist with specific issues.</p>
              <Link to="/contact" className="border-b border-slate-900 pb-0.5 font-medium text-slate-900">
                Contact Us
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
